import { render, staticRenderFns } from "./ConfirmEventReportSent.vue?vue&type=template&id=4ad93b37&scoped=true&"
import script from "./ConfirmEventReportSent.vue?vue&type=script&lang=ts&"
export * from "./ConfirmEventReportSent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad93b37",
  null
  
)

export default component.exports